import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

export const CANVAS_SIZES: Record<EditorCanvas, { defaultFrameWidth: number }> =
  {
    desktop: {
      defaultFrameWidth: 1440 as const,
    },
    tablet: {
      defaultFrameWidth: 810 as const,
    },
    mobile: {
      defaultFrameWidth: 393 as const,
    },
  };
